export default "__VITE_ASSET__BH1cPT5V__"